import React, { useEffect } from 'react'
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { officesOptionsMap, showNewOfficeSection, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"
import { offices as idOffices } from "@signals"

import { array, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { AppAsyncOfficesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

export default function UserOfficesField() {

	const { offices, setOfficesInfo } = useAdminUsersInfo(userPayload.peek()?.offices, "offices")
	const { errors, isValid } = useValidatorSeeker(
		{ offices: offices },
		object({
			offices: array().min(1, 'Must provide an office')
		})
	)

	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), offices: isValid }
	}, [isValid])

	return <Box sx={{ display: "flex", alignItems: "start", justifyContent: "space-evenly", gap: 2 }}>
		<AppAsyncOfficesAutocomplete
			method="POST"
			multiple
			urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/offices`}
			onFinishAjax={options => {
				officesOptionsMap.value = { ...officesOptionsMap.value, ...Object.fromEntries(options.map(o => [String(o.value), o.label])) }
				const selected = options?.filter(opt => opt.selected)
				if (selected) {
					setOfficesInfo(selected.map(opt => opt.value))
				}
			}}
			value={offices}
			onChange={e => setOfficesInfo(e.target.value)}
			filters={{
				idOfficePickup: idOffices.value,
				selected: [...new Set([...userPayload.value.offices, ...idOffices.value])]
			}}
			error={errors?.offices}
		/>
		<ButtonIconSeeker
			icon={showNewOfficeSection.value ? "xmark" : "plus"}
			tooltip={showNewOfficeSection.value ? "Close new office form" : "Create new office"}
			onClick={() => showNewOfficeSection.value = !showNewOfficeSection.value}
		/>
	</Box>
}